// Product brand shown in the UI (login page, footers, page title). A committed .env is blocked
// by the root .gitignore, so the default lives here; set REACT_APP_BRAND_NAME to override it.
export const BRAND = (process.env.REACT_APP_BRAND_NAME || "HichPlan").trim() || "HichPlan";
